import { c as _c } from "react/compiler-runtime";
import { track } from "@opensea/analytics";
import { useOnChange, usePrevious } from "@opensea/ui-kit/hooks";
import { useAccount } from "@opensea/wallet";
export const useSwitchChainTracking = () => {
  const $ = _c(3);
  const {
    chainId
  } = useAccount();
  const previousChainId = usePrevious(chainId);
  let t0;
  if ($[0] !== chainId || $[1] !== previousChainId) {
    t0 = () => {
      if (chainId !== undefined && previousChainId !== undefined) {
        track("Switch Chain", {
          previousChainId,
          chainId
        });
      }
    };
    $[0] = chainId;
    $[1] = previousChainId;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  useOnChange(chainId, t0);
};